<template>
  <div
    class="
      tw-bg-white tw-px-4 tw-py-3 tw-flex tw-items-center tw-justify-between
      sm:tw-px-6
    "
  >
    <div
      class="sm:tw-flex-1 sm:tw-flex sm:tw-items-center sm:tw-justify-between"
    >
      <div></div>
      <div>
        <nav
          class="tw-relative tw-z-0 tw-inline-flex tw--space-x-px tw-flex-wrap"
          aria-label="Pagination"
        >
          <a
            class="
              tw-relative
              tw-inline-flex
              tw-items-center
              tw-px-2
              tw-py-2
              tw-py-2
              tw-bg-white
              tw-text-sm
              tw-font-medium
              tw-text-white
              tw-bg-noraBlue-400
              hover:tw-bg-noraBlue-500
            "
            @click="getPreviousPage(CurrentPage)"
          >
            <span v-if="showPreviousLink" class="tw-sr-only">Previous</span>
            <ChevronLeftIcon class="tw-h-5 tw-w-5" aria-hidden="true" />
          </a>

          <a
            aria-current="page"
            class="
              tw-bg-white tw-text-noraBlue-400
              hover:tw-bg-noraGray-200
              tw-relative
              tw-inline-flex
              tw-items-center
              tw-font-bold
              tw-px-4
              tw-py-2
              tw-text-sm
              tw-font-medium
            "
            v-for="page in visiblePages"
            :key="page"
            :class="[
              CurrentPage == page
                ? 'tw-bg-noraGray-200 tw-pointer-events-none'
                : '',
              page === '...'
                ? 'tw-text-noraGray-400 tw-pointer-events-none'
                : '',
            ]"
            @click="getPage(page)"
          >
            {{ page }}
          </a>

          <a
            href="#"
            class="
              tw-relative
              tw-inline-flex
              tw-items-center
              tw-px-2
              tw-py-2
              tw-bg-white
              tw-text-sm
              tw-font-medium
              tw-text-white
              tw-bg-noraBlue-400
              hover:tw-bg-noraBlue-500
            "
            v-if="showNextLink"
            @click="getNextPage(CurrentPage)"
          >
            <span class="tw-sr-only">Next</span>
            <ChevronRightIcon class="tw-h-5 tw-w-5" aria-hidden="true" />
          </a>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/vue/solid";

export default {
  name: "Pagination",
  props: {
    CurrentPage: Number,
    TotalPages: Number,
    TotalProducts: Number,
    MaximumPages: Number,
  },
  data() {
    return {
      MaxPages: this.$props.MaximumPages || 10,
    };
  },
  computed: {
    showPreviousLink() {
      return this.CurrentPage == 0 ? false : true;
    },
    showNextLink() {
      return this.CurrentPage == this.TotalPages ? false : true;
    },
    visiblePages() {
      if (this.TotalPages < 7) {
        const visiblePages2 = [...this.createListFromRange(1, this.TotalPages)];
        return visiblePages2;
      } else {
        const visiblePages = [
          ...this.getFirstThreePages(this.TotalPages),
          ...this.getCurrentThreePages(this.CurrentPage, this.TotalPages),
          ...this.getLastThreePages(this.TotalPages),
        ];
        this.addPlaceholdersToPagination(visiblePages);
        return visiblePages;
      }
    },
  },

  methods: {
    getPreviousPage(page) {
      this.$emit("pageChange", page - 1);
    },
    getNextPage(page) {
      this.$emit("pageChange", page + 1);
    },
    getPage(page) {
      this.$emit("pageChange", page);
    },
    getCurrentThreePages(currentPage, totalPageCount) {
      if (currentPage < 3 || currentPage >= totalPageCount - 1) {
        return [];
      }

      return this.createListFromRange(
        currentPage < 5 ? currentPage : currentPage - 1,
        totalPageCount - 3
      ).slice(currentPage === 3 ? 1 : 0, currentPage < 5 ? 2 : 3);
    },
    getFirstThreePages(totalPageCount) {
      return this.createListFromRange(1, totalPageCount).slice(0, 3);
    },
    getLastThreePages(totalPageCount) {
      return this.createListFromRange(totalPageCount - 2, totalPageCount);
    },
    addPlaceholdersToPagination(pages) {
      pages.forEach((page, index) => {
        if (page === "...") {
          return;
        }

        const nextPageIndex = index + 1;

        if (page + 1 !== pages[nextPageIndex]) {
          pages.splice(nextPageIndex, 0, "...");
        }
      });
    },
    createListFromRange(start, stop) {
      return [...Array(stop - start + 1).keys()].map((key) => key + start);
    },
  },
  components: {
    ChevronLeftIcon,
    ChevronRightIcon,
  },
};
</script>
